module.exports = __webpack_public_path__ + "media/images/lb/058-1f9b6b885f749adf82e7178241c12e07.svg";